import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { State, getOperatorsSettings } from '@app/app.reducer';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Pipe({
  name: 'localizedDate',
  pure: false,
  standalone: true
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(
    private translateService: TranslateService,
    private datePipe: DatePipe,
    private store: Store<State>
  ) {}

  //combine this pipe with async pipe to transform with observable
  transform(
    value: any,
    customPattern?: string,
    forceFormat?: 'default',
    timeZone: string = null
  ): Observable<string> | string {
    const currentLang = this.translateService.currentLang;

    const pattern = customPattern || 'MMM d, yyyy';

    if (customPattern || forceFormat === 'default') {
      return this.datePipe.transform(value, pattern, timeZone, currentLang);
    }

    return this.store.select(getOperatorsSettings).pipe(
      filter((data) => !!data && !!data['dateFormats']),
      map(({ dateFormats }) => {
        const patternFromSettings = dateFormats[currentLang] || pattern;

        // this is needed to avoid IE11 bug with date format
        if (value !== 'Invalid Date') {
          return this.datePipe.transform(value, patternFromSettings, timeZone, currentLang);
        } else {
          return 'Invalid date';
        }
      })
    );
  }
}
